import { Field, useFormikContext } from "formik";
import { useIntl } from "react-intl";

import * as Yup from "yup";


export default function MarketPlace() {
  const intl = useIntl();
  const { errors, touched } = useFormikContext<ValidSchema>();

  const validSchema = Yup.object({
    cardName: Yup.string(),
    cardNumber: Yup.string(),
    cardExpiryMonth: Yup.string(),
    cardExpiryYear: Yup.string(),
    cardCvv: Yup.string(),
  });

  type ValidSchema = Yup.InferType<typeof validSchema>;

  return (
    <div className="pb-5" data-wizard-type="step-content">
      <h4 className="mb-10 font-weight-bold text-dark">
        {intl.formatMessage({ id: 'CHECKOUT.PAYMENT.CONTENT' })}
      </h4>
      <div className="row">
        <div className="col-xl-6">
          <div className="form-group">
            <label className='required form-label'>{intl.formatMessage({ id: 'CHECKOUT.PAYMENT.CARD_NAME' })}</label>
            <div className='fv-row mb-4 form-floating'>
              <Field
                type='text'
                className='form-control'
                name='cardName'
                placeholder=''
              />
              <label>{intl.formatMessage({ id: 'CHECKOUT.PAYMENT.CARD_NAME' })}</label>
            </div>
            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
              {errors.cardName && touched.cardName && (
                <div className='fv-help-block'>
                  {errors.cardName}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="form-group">
            <label className='required form-label'>{intl.formatMessage({ id: 'CHECKOUT.PAYMENT.CARD_NUMBER' })}</label>
            <div className='fv-row mb-4 form-floating'>
              <Field
                type='text'
                className='form-control'
                name='cardNumber'
                placeholder=''
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                  // max length 16
                  if (event.currentTarget.value.length >= 16) {
                    event.preventDefault();
                  }
                }}
              />
              <label>{intl.formatMessage({ id: 'CHECKOUT.PAYMENT.CARD_NUMBER' })}</label>
            </div>
            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
              {errors.cardNumber && touched.cardNumber && (
                <div className='fv-help-block'>
                  {errors.cardNumber}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-4">
          <div className="form-group">
            <label className='required form-label'>{intl.formatMessage({ id: 'CHECKOUT.PAYMENT.CARD_EXPIRY_MONTH' })}</label>
            <div className='fv-row mb-4 form-floating'>
              <Field
                type='text'
                className='form-control'
                name='cardExpiryMonth'
                placeholder=''
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                  if (event.currentTarget.value.length >= 2) {
                    event.preventDefault();
                  }
                }}
              />
              <label>{intl.formatMessage({ id: 'CHECKOUT.PAYMENT.CARD_EXPIRY_MONTH' })}</label>
            </div>
            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
              {errors.cardExpiryMonth && touched.cardExpiryMonth && (
                <div className='fv-help-block'>
                  {errors.cardExpiryMonth}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-xl-4">
          <div className="form-group">
            <label className='required form-label'>{intl.formatMessage({ id: 'CHECKOUT.PAYMENT.CARD_EXPIRY_YEAR' })}</label>
            <div className='fv-row mb-4 form-floating'>
              <Field
                type='text'
                className='form-control'
                name='cardExpiryYear'
                placeholder=''
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                  if (event.currentTarget.value.length >= 4) {
                    event.preventDefault();
                  }
                }}
              />
              <label>{intl.formatMessage({ id: 'CHECKOUT.PAYMENT.CARD_EXPIRY_YEAR' })}</label>
            </div>
            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
              {errors.cardExpiryYear && touched.cardExpiryYear && (
                <div className='fv-help-block'>
                  {errors.cardExpiryYear}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-xl-4">
          <div className="form-group">
            <label className='required form-label'>{intl.formatMessage({ id: 'CHECKOUT.PAYMENT.CARD_CVV' })}</label>
            <div className='fv-row mb-4 form-floating'>
              <Field
                type='text'
                className='form-control'
                name='cardCvv'
                placeholder=''
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                  if (event.currentTarget.value.length >= 3) {
                    event.preventDefault();
                  }
                }}
              />
              <label>{intl.formatMessage({ id: 'CHECKOUT.PAYMENT.CARD_CVV' })}</label>
            </div>
            <div className='fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback mb-4'>
              {errors.cardCvv && touched.cardCvv && (
                <div className='fv-help-block'>
                  {errors.cardCvv}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
